import { ReconciliationSettingData } from '@/features/ap_payees/components/PayeeDetailDrawer/types';
import { useGetFlags } from '@/hooks/useFeatureFlag';
import { useMemo } from 'react';

type UseReconciliationSettingVisibilityParams = {
  data?: ReconciliationSettingData;
};

export const useReconciliationSettingVisibility = ({
  data,
}: UseReconciliationSettingVisibilityParams) => {
  const isFeatureEnabled = useGetFlags('PAYEE_RECONCILIATION_SETTING');

  const isVisible = useMemo(() => {
    if (!isFeatureEnabled) {
      return false;
    }

    // The BE returns null while the office has not enabled 突合サービス連携, which is
    // what hides both the section and its anchor item.
    return !!data?.ap_payee_reconciliation_setting;
  }, [isFeatureEnabled, data?.ap_payee_reconciliation_setting]);

  return {
    isVisible,
  };
};
